export enum DocumentActions {
  approved,
  delivered,
  issued,
  upgradeToBillingNote,
  upgradeToCashInvoice,
  upgradeToBillingNotePartials,
  upgradeToReceivableInvoice,
  upgradeToInvoice,
  upgradeToInvoicePartials,
  upgradeToReceipt,
  upgradeToBatchReceipt,
  upgradeToPurchaseOrder,
  upgradeToPurchase,
  upgradeToCreditNote,
  upgradeToDebitNote,
  upgradeToExpense,
  upgradeToPaymentSlip,
  receiptPayment,
  alreadyReceipt,
  void,
  reset,
  upgradeToBatchBillingNote,
  upgradeToCashInvoicePartials,
  upgradeToReceiptPartials,
  upgradeToBillingNoteDeposit,
  upgradeToInvoiceDeposit,
  upgradeToCashInvoiceDeposit,
  upgradeToBillingNoteLastDeposit,
  upgradeToInvoiceLastDeposit,
  upgradeToCashInvoiceLastDeposit,
  editPayment,
}

export enum DocumentContactCompanyChangeType {
  contact = 1,
  company = 3,
  both = 5,
  notBoth = 7,
}

export enum DocumentTypes {
  default = 0,
  purchaseOrder = 1,
  quotation = 3,
  billingNote = 5,
  taxInvoice = 7,
  receipt = 9,
  separateReceipt = 10, // UserAnalyticEvents
  expense = 13,
  vendor = 15,
  withHoldingTax = 17,
  billingNotePartials = 19,
  taxInvoicePartails = 21,
  purchase = 23,
  receivableInvoice = 25,
  adjustInventory = 29,
  creditNote = 31,
  debitNote = 33,
  cashInvoice = 35,
  paymentSlip = 37,
  paymentSlipReverseAccrual = 38, // UserAnalyticEvents
  TransferWarehouse = 49,
  journalEntry = 51,
  purchaseVoucher = 53,
  salesVoucher = 55,
  paymentVoucher = 57,
  receiptVoucher = 59,
  conversionBalance = 61,
  SupplierInvoice = 65,
  BatchTaxFiling = 67,
  FixedAsset = 69,
  Depreciation = 71,
  BankTransfer = 73,
  closePeriod = 75,
  closePeriodJV = 77,
  draftClosePeriod = 161,
  payroll = 201,
  payrollDetail = 202,
  employee = 203,
  PayrollPayment = 204,
  tawi50 = 205,
}

export enum CreateUpdateMode {
  create = 1,
  update = 3,
  view = 5,
  upload = 7,
  upgrade = 9,
  delete = 11,
  duplicate = 13,
  batchCreate = 15,
  partialPayment = 17,
  depositPayment = 19,
}

export enum CreditTypes {
  days = 1,
  cash = 3,
  cashNoDateDisplay = 4,
  noDateDisplay = 5,
}

export enum DiscountTypes {
  percent = 1,
  value = 3,
}

export enum DocumentStatus {
  awaiting = 1,
  approved = 3,
  pendingPayment = 4,
  approvedAndProcessed = 5,
  void = 7,
  rejected = 9,
  billingNotePartials = 11,
  invoicePartials = 13,
  billingNotePartialsProcessed = 15,
  invoicePartialsProcessed = 17,
  invoiceDelivered = 19,
  invoiceReceived = 21,
  pushPayAwaiting = 23,
  pushPayProcessed = 25,
  pushPayRejected = 27,
  pushPayPartial = 29,
  pushPayPendingPayments = 31,
  paid = 33,
  paidByPaymentSlip = 34,
  processed = 35,
  received = 37,
  delivered = 39,
  cashInvoicePartials = 41,
  cashInvoicePartialsProcessed = 43,
  refunded = 45,
  receiptPartials = 47,
  billingNoteDeposit = 49,
  invoiceDeposit = 51,
  billingNoteDepositProcessed = 53,
  invoiceDepositProcessed = 55,
  cashInvoiceDeposit = 57,
  cashInvoiceDepositProcessed = 59,
  receiptDeposit = 61,
  pushPayDeposit = 63,
  deposited = 65,
  receivedByPaymentSlip = 66,
}

export enum QuotationStatus {
  awaiting = 1,
  approved = 3,
  approvedAndProcessed = 5,
  void = 7,
  rejected = 9,
  billingNotePartials = 11,
  invoicePartials = 13,
  billingNotePartialsProcessed = 15,
  invoicePartialsProcessed = 17,
  cashInvoicePartials = 41,
  cashInvoicePartialsProcessed = 43,
  deposited = 45,
}

export enum BillingNoteStatus {
  awaiting = 1,
  approved = 3,
  approvedAndProcessed = 5,
  void = 7,
  delete = 9,
  received = 37,
}

export enum InvoiceStatus {
  awaiting = 1,
  invoiceDelivered = 3,
  paid = 5,
  void = 7,
  invoiceReceived = 9,
  receiptPartials = 11,
}

export enum ReceiptStatus {
  awaiting = 1,
  paid = 5,
  void = 7,
}

export enum PurchaseOrderStatus {
  awaiting = 1,
  approved = 3,
  paid = 5,
  approvedAndProcessed = 9,
  void = 7,
  // pushPayAwaiting = 11,
  // pushPayProcessed = 13,
  // pushPayRejected = 15,
  // pushPayPartial = 17,
  // pushPayPendingPayments = 19
}

export enum PurchaseStatus {
  awaiting = 1,
  approved = 3,
  pendingPayment = 4,
  paidByPaymentSlip = 6,
  paid = 5,
  void = 7,
  received = 21,
  receivedByPaymentSlip = 23,
  // pushPayAwaiting = 11,
  // pushPayProcessed = 13,
  // pushPayRejected = 15,
  // pushPayPartial = 17,
  // pushPayPendingPayments = 19
}

export enum PaymentSlipStatus {
  awaiting = 1,
  approved = 3,
  pendingPayment = 4,
  paid = 5,
  void = 7,
  // approvedAndProcessed = 9,
  received = 11,
}
export enum DebitNoteStatus {
  awaiting = 1,
  approved = 3,
  paid = 5,
  void = 7,
  delete = 9,
  delivered = 11,
  received = 13,
}
export enum CreditNoteStatus {
  awaiting = 1,
  approved = 3,
  approvedAndProcessed = 5,
  void = 7,
  delete = 9,
  delivered = 11,
  received = 13,
  refunded = 21,
}

export enum ExpenseStatus {
  awaiting = 1,
  // approved = 3,
  pendingPayment = 4,
  paid = 5,
  paidByPaymentSlip = 6,
  void = 7,
  // approvedAndProcessed = 9,
  received = 11,
}

export enum WithHoldingTaxStatus {
  awaiting = 1,
  // approved = 3,
  processed = 5,
  void = 7,
}

export enum GridSearchStatus {
  showAll = -1,
  deleted = -2,
}

export enum TransactionStatus {
  delete = 0,
  awaiting = 1,
  approved = 5,
  void = 9,
}

export enum PaymentMethod {
  none = 0,
  cash = 1,
  cheque = 3,
  transfer = 5,
  TransferByKConnect = 51,
  creditCard = 7,
  pushPay = 9,
  pettyCash = 11,
  other = 13,
}

export enum FinancialTransactionType {
  debit = 1,
  credit = 3,
}

export enum JournalEntryStatus {
  delete = 0,
  awaiting = 1,
  reset = 2,
  approved = 5,
  void = 9,
}

export enum ClosingPeriodStatus {
  delete = 0,
  awaiting = 1,
  approved = 5,
  void = 9,
}

export enum BookOfAccountStatus {
  delete = 0,
  awaiting = 1,
  approved = 5,
  void = 9,
}

export enum ChartOfAccountCategory {
  None = 0,
  Assets = 1,
  Liabilities = 2,
  Equity = 3,
  Revenue = 4,
  Expenses = 5,
}

export enum BankAccountType {
  SavingAccount = 1,
  CurrentAccount = 3,
  CreditCardAccount = 5,
  DepositAccount = 7,
}

export enum ContactTypes {
  client = 3,
  vendor = 5,
  vendorAndClient = 7,
}

export enum ContactGroups {
  individual = 1,
  juristic = 3,
}

export enum DocumentReferenceTypes {
  importDocument = 1,
  partialPayments = 3,
  batch = 5,
  etax = 7,
  miigratePartialPayments = 9,
  batchPartialPayments = 11,
  depositFirst = 13,
  depositLast = 15,
}

export enum ProductTypes {
  Service = 1,
  ProductWithNoStock = 3,
  ProductWithStock = 5,
}

export enum showMoreDescription {
  DescriptionLength = 90,
  DescriptionLine = 3,
}

export enum InventoryType {
  Initial = 3,
  BroughtForward = 5,
  In = 7,
  TransferIn = 11,

  Out = 17,
  TransferOut = 21,
  CreditNote = 25,
  DebitNote = 27,
  InternalUse = 29,

  Hold = 31,
  AdjustIn = 35,
  AdjustOut = 39,
}

export enum VatType {
  InclusiveVat = 1,
  ExclusiveVat = 3,
  ZeroVat = 5,
  NoVat = 7,
}

export enum ChartOfAccountId {
  Cash = 100,
  AccountsReceivable = 101,
  Sales = 102,
  ServicesRevenue = 103,
  SalesTax = 104,
  UnamortizationSalesTax = 105,
  WithHeldTax = 106,
  FinishedGoods = 107,
  CostofGoodsSold = 108,
  Cheques = 109,
  ChequeReceivedInAdvance = 110,
  CurrentAccount = 111,
  SavingAccount = 112,
  CreditCardReceivable = 113,
  BankFees = 114,
  CreditCardFees = 115,
  OthersIncome = 116,
  TradePayable = 117,
  InputVat = 118,
  UndueInputVat = 119,
  WHT_PND2 = 120,
  WHT_PND3 = 121,
  WHT_PND53 = 122,
  WHT_PND54 = 123,
  CreditCardPayable = 124,
  Postdatedcheque = 125,
  CashShortCashOver = 126,
  Rounding = 127,
  ProfitAndLoss = 128,
  WHT_PND1 = 129,

  MarketingAdvertising = 1001,
  Promotions,
  Entertainment,
  TravelAccomodations,
  VehicleExpenses,
  FreightCourierLogistics,
  GoodsMaterialsPackaging,
  PurchasedForSell,
  PurchasedForServicing,
  PurchasedForSampleOrPremium,
  OfficeExpenses,
  ComputerITequipment,
  FurnitureOfficeEquipment,
  MessengerPostage,
  SoftwareApplications,
  OfficeSuppliesStationery,
  OfficeSpace,
  Telephone, //1018
  Internet,
  ServiceContractorExpenses,
  GeneralServicesFreelance,
  AccountingServices,
  PayrollEmployeeBenefits,
  SalaryWages,
  Allowances,
  SocialSecurityFunds,
  EmployeeBenefits,
  Rent,
  DepositGuarantee,
  Insurance,
  BankCharges,
  TaxesAndLicenses,
  OtherExpenses,
  Personal,
  Commissions,
  RepairAndMaintenance,
  InterestExpenses,
  GeneralExpenses,
  OverTime,
  WaterPlumbing,
  Electricity,
  SalesmanCommission, //1042

  NonStockProduct = 2001,
  SparepartProduct = 2002,
  SampleProduct = 2003,
  FreemiumProduct = 2004,
  SupplyProduct = 2005,
}

export enum RemainingCollectedType {
  none = 0,
  cashShortOrOver = 1,
  cashDiscount = 3,
  SalesCashShortOrOver = 51,
  SalesDiscount = 53,
  SalesBankFee = 55,
  SalesExchangeRateDiff = 57,
  ExchangeRateDiff = 5, //for cn
  CustomCOA = 80, //for cn
}

export enum BankAccountTypes {
  SavingAccount = 1,
  CurrentAccount = 3,
  CreditCardAccount = 5,
  DepositAccount = 7,
}

export enum BankNameType {
  KasikornBank = 2,
  SiamCommercialBank = 5,
  BankOfAyudhya = 9,
}

export enum BankCode {
  BangkokBank = '002',
  KasikornBank = '004',
  KrungthaiBank = '006',
  TMB = '011',
  SiamCommercialBank = '014',
  StandardCharteredBankThai = '020',
  CIMBThaiBank = '022',
  UnitedOverseasBankThai = '024',
  BankofAyudhya = '025',
  GovernmentSavingsBank = '030',
  ThanachartBank = '065',
  LandandHousesBank = '073',
  KiatnakinBank = '073',
  Citibank = '017',
  TiscoBank = '067',
}
export enum BankShortName {
  BBL = '002',
  KBANK = '004',
  KTB = '006',
  TMB = '011',
  SCB = '014',
  SCBT = '020',
  CIMB = '022',
  UOB = '024',
  BAY = '025',
  GSB = '030',
  TBANK = '065',
  LHBANK = '073',
  KNK = '073',
  CITI = '017',
  TISCO = '067',
}

export enum Entity {
  Default = 0,
  PND3 = 1,
  PND53 = 3,
  PND1 = 15,
  PND1K = 5,
  PND1KSpecial = 7,
  PND2 = 9,
  PND2K = 11,
  PND3K = 13,
}

export enum IncomeType {
  default = 0,
  salary = 1,
  commission = 3,
  licensing = 5,
  interest = 7,
  netProfit30 = 9,
  netProfit25 = 11,
  netProfit20 = 13,
  netProfitOther = 15,
  taxExemption = 17,
  dividenFromShareOfProfit = 19,
  portionOfNetProfit = 21,
  recognitionOfProfit = 23,
  taxOther = 25,
  revenueDepartmentTax = 27,
  others = 29,
}

export enum TaxPayments {
  deductTaxWithheld = 1,
  paidTaxForRecipientEveryTime = 3,
  paidTaxForRecipientOneTime = 5,
  others = 7,
}

export enum FilterChart {
  filter30Days = 30,
  filter60Days = 60,
  filter90Days = 90,
  filter180Days = 180,
  filterLastYear = 365,
  filterCurrentYear = -1,
}

export enum DashboardChartTypes {
  income = 1,
  expense = 3,
}

export enum TaxTypes {
  percent = 1,
  value = 3,
}

export enum CompanyTypeEnum {
  PrivateWithTax = 10, //นิติบุคคล จดภาษี
  PrivateWithoutTax = 20, //นิติบุคคล ไม่จดภาษี
  Personal = 30, //บุคคลธรรมดา ไม่จดภาษี
  //PublicWithTax = 40,
  PersonalWithTax = 40, //บุคคลธรรมดา จดภาษี
  PartnershipLimitedWithTax = 50,
  PartnershipLimitedWithoutTax = 60,
}

export enum ReportTypes {
  sales = 10,
  salesTeamReport = 11,
  salesTax = 12,
  salesTaxAdvance = 16,
  simpleSales = 13,
  accountReceivable = 14,
  accountReceivableAging = 15,
  purchase = 20,
  purchaseTax = 21,
  accountPayable = 22,
  accountPayableAging = 23,
  purchaseByProduct = 24,
  purchaseByProductAdvance = 25,
  clients = 30,
  vendor = 40,
  paymentCollection = 50,
  salesByProduct = 60,
  salesByProductAdvance = 61,
  salesByPerson = 62,
  salesByPersonAdvance = 63,
  salesByCustomer = 64,
  salesByCustomerAdvance = 65,
  quotation = 70,
  billingNote = 80,
  receiveInventory = 90,
  stocksReport = 91,
  groupStockReport = 92,
  simpleGroupStockReport = 93,
  expense = 100,
  withHoldingTax = 110,
  profitAndLoss = 120,
  receipt = 130,
  creditNote = 140,
  debitNote = 150,
  taxInvoice = 160,
  payroll = 170,
  payrollSummary = 171,
  payrollGroup = 172,
  payrollSscSummary = 173,
  tawi50 = 174,
  contactGrid = 180,
  productGrid = 190,
  exportContact = 200,
  exportProduct = 210,
  receivables = 220,
  payables = 240,
  generalLedger = 260,
  journalEntry = 270,
  payment = 280,
  inputTax = 290,
  outputTax = 291,
  foreignInputTax = 294,
  paymentSlip = 300,
}

export enum DataRange {
  Unset = -1,
  Default = 0,
  CurrentMonth = 1,
  PreviousMonth = 3,
  Manual = 5,
  CurrentYear = 7,
  PreviousYear = 9,
  FiscalYear = 15,
  Months = 17,
  Days = 19,
  ManualMonth = 21,
}

export enum RunningNumberType {
  Default = 1,
  YearMonthDay = 2,
  YearMonth = 3,
  Month = 5,
  Year = 7,
  FreeHand = 9,
}

export enum DefaultColors {
  quotation = '#f49739',
  billingNote = '#754595',
  taxInvoice = '#2c97ce',
  receipt = '#56af31',
  purchaseOrder = '#e72168',
  purchase = '#b75f5f',
  creditNote = '#0b4792',
  debitNote = '#28A5A0',
  cashInvoice = '#006000',
}

export enum DefaultColorsType {
  quotation = 3,
  billingNote = 5,
  taxInvoice = 7,
  receipt = 9,
  purchaseOrder = 1,
  purchase = 23,
  creditNote = 31,
  debitNote = 33,
  cashInvoice = 35,
}

export enum DocumentFooterSetting {
  OldDefault = 0,
  NewDefault = 1,
  Custom = 2,
}

export enum RuleCompileStatus {
  none = 0,
  pending = 1,
  execute = 3,
  success = 5,
  error = 7,
  whtWarning = 9,
}

export enum ExpenseCategoryViewTypes {
  accounting = 1,
  business = 3,
}

export enum SeparateReceiptTypes {
  accounting = 1,
  business = 3,
}
export enum CompanyRole {
  Founder = 1, //ผู้ก่อตั้ง / เจ้าของธุรกิจ -> เจ้าของกิจการ
  Sales = 3, // พนักงานขาย / จัดซื้อ -> พนักงาน
  Bookkeeper = 5, // เจ้าหน้าที่ธุรการ
  CompanyAccountant = 7, // นักบัญชีในกิจการ
  AccountingAccountant = 9, // นักบัญชี / ผู้ตรวจสอบบัญชีในสำนักงานบัญชี -> นักบัญชี
  FreelanceAccountant = 11, // นักบัญชี / ผู้ตรวจสอบบัญชีอิสระ
  AdminHR = 13,
  //v.2022
  //Founder = 1, //เจ้าของธุรกิจ
  //CompanyAccountant = 7 //นักบัญชีในบริษัท
  //Sales = 3 //พนักงาน
  //FreelanceAccountant = 11 //สำนักงานบัญชี/นักบัญชีอิสระ
  Student = 15, //นักเรียน/นักศึกษา
}
export enum EmployeeNumber {
  UnderTen = 1, // 1 - 10 คน
  UnderThirty = 3, // 11 - 30 คน
  UnderFifty = 5, // 31 - 50 คน
  MoreFifty = 9, // มากกว่า 50 คน
}

export enum CompanyAge {
  JustStarted = 1, // เพิ่มเริ่มจัดตั้ง
  UnderThree = 3, // 1- 3 ปี
  UnderSeven = 5, // 3 - 7 ปี
  Other = 7, // อื่น (โปรดระบุ)
  MoreThanSeven = 9, //มากกว่า 7 ปี - v.2
}
export enum BusinessCategory {
  Retail = 1, // ค้าปลีก / ส่ง
  Constructions = 3, // บริการรับเหมาก่อสร้าง
  ImportExport = 5, // ธุรกิจนำเข้า/ส่งออก
  ProfessionalServices = 7, // บริการด้านวิชาชีพ
  Educations = 9, // สถาบันการศึกษา
  ArchitectDesign = 11, // สถาปนิก / ออกแบบ
  CosmeticsSupplementaryFood = 13, // เสริมความงาม/ ยา / อาหารเสริม
  Restaurants = 15, // ร้านอาหาร
  ApartmentHotelHostelSpa = 17, // อพาร์เมนท์ / โรงแรม / โฮสเทล
  Logistics = 19, // ขนส่ง
  Travel = 21, // ท่องเที่ยว
  Jewelry = 23, // เครื่องประดับ
  Manufacturing = 25, // โรงงานผลิต
  MediaPrinting = 27, // สื่อและโฆษณา / สิ่งพิมพ์
  ClothingFashion = 29, // เสื้อผ้าและแฟชั่น
  Other = 31, // อื่น (โปรดระบุ)

  DropShipOnline = 33, // ดรอปชิปปิ้ง ขายสินค้าออนไลน์- v.2
  Wholesale = 35, //ขายส่ง ฝากขาย- v.2
  ProductWithInstallation = 37, // ขายสินค้าพร้อมบริการติตตั้ง- v.2
  GeneralService = 39, // บริการทั่วไป- v.2

  //v.2022
  Service = 47, //ธุรกิจบริการ
  Merchandising = 43, //ธุรกิจซื้อมาขายไป (มีหน้าร้าน)
  TradingECommerce = 45, //ขายของออนไลน์ -> ขายของผ่าน Shopee / Lazada
  //Constructions = 3 //ธุรกิจรับเหมาก่อสร้าง
  //Restaurants = 15 //ธุรกิจอาหารและเครื่องดื่ม
  //ApartmentHotelHostelSpa = 17 //โรงแรม/ที่พัก
  PropertyManagement = 49, //ธุรกิจอสังหาริมทรัพย์/ให้เช่า
  //ImportExport = 5 //ธุรกิจนำเข้า-ส่งออก
  //Manufacturing = 25 //โรงงานผลิต
  Freelance = 41, //อาชีพอิสระ/ฟรีแลนซ์
  //Other = 31 //อื่นๆ

  //v.03/2022
  // Service = 47, //ธุรกิจบริการ
  // Freelance = 41, //อาชีพอิสระ/ฟรีแลนซ์
  // TradingECommerce = 45, //ขายของผ่าน Shopee/Lazada
  // Restaurants = 15 //ร้านอาหารและคาเฟ่
  // Merchandising = 43, //ซื้อมาขายไป (มีหน้าร้าน)
  // ApartmentHotelHostelSpa = 17 //โรงแรม/ที่พัก
  // ImportExport = 5 //ธุรกิจนำเข้า-ส่งออก
  // Constructions = 3 //ธุรกิจรับเหมาก่อสร้าง
  // Manufacturing = 25 //โรงงานผลิต
  // PropertyManagement = 49, //ธุรกิจอสังหาริมทรัพย์/ให้เช่า
  // Other = 31 //อื่นๆ
}
export enum AccountingType {
  Yourself = 1, // ทำบัญชีเองภายในกิจการ
  Hire = 3, // จ้างสำนักงานบัญชี
}
export enum UsingPurpose {
  Dashboard = 1, // ดูรายงาน และภาพรวมเพื่อการบริหารธุรกิจ
  BusinessDocuments = 3, // ออกเอกสารซื้อ ขายรวมถึงการบันทึกค่าใช้จ่ายของบริษัท | 2.เปิดบิลขาย ดูรายได้
  ManageInventory = 5, // บริหารสต๊อคสินค้า |2.จัดการสต็อกสินค้า
  AccountingTaxService = 7, // ใช้บริการด้านบัญชีและภาษีให้กับลูกค้าที่ดูแลอยู่
  AccountingTransactions = 9, // บันทึกรายการบัญชีและภาษีต่างๆ เพื่อจัดทำรายงานทางบัญชีและภาษีรายเดือนในกิจการ | 2.ทำบัญชีและภาษี
  ReplaceOldAccounting = 11, // ใช้ทดแทนระบบบัญชีเดิมที่ใช้งานอยู่
  Other = 13, // อื่น (โปรดระบุ)
  Expenses = 15, //v.2 บันทึกค่าใช้จ่าย
  Payrolls = 17, //v.2 ทำเงินเดือน จัดการข้อมูลพนักงาน,
  PointOfSales = 19, //v.3 บริหารการขายหน้าร้าน จัดการออเดอร์
  //v.2022 Duplicate, if change, please find 'FindNewSoftware = 21'
  FindNewSoftware = 21, //ต้องการเปลี่ยนระบบบัญชี
  UseReportForBusiness = 23, //ดูรายงานเพื่อการบริหารธุรกิจ
  PayrollAndManageEmployee = 25, //ทำเงินเดือนและจัดการข้อมูลพนักงาน
  StockProducts = 27, //บริหารจัดการสต็อกสินค้า
}
export enum BusinessType {
  SellingProducts = 1, //ซื้อขายสินค้า
  SellingServices = 3, //ให้บริการ
  SellingBoth = 5,
  Custom = 7, //อื่นๆ
  Manufacturing = 9,
}

export enum AccountingServiceType {
  Own = 1,
  Employment = 3,
  AccountingFirm = 5,
}

export enum CustomDocumentModel {
  switchProductItemSellToBuy = 1,
}
export enum ProductNonInventoryType {
  NonStockProduct = 1,
  SparepartProduct = 3,
  SampleProduct = 5,
  FreemiumProduct = 7,
  SupplyProduct = 9,
  OthersProduct = 11,
}

export enum RoleNameList {
  Owner = 3,
  AccountingFirm = 14,
  Accountant = 4,
  SalesManager = 5,
  SeniorSales = 6,
  SalesAdmin = 7,
  SalesAndPurchasingOfficer = 12,
  // HRManager = 18 //Staging is 18
  HRManager = 15, //Production is 15
}
export enum CompanyUserStatus {
  Deleted = 0, //isActive false
  Accepted = 1, //isActive true
  Holding = 2, //Lockout Enabled
  Rejected = 3,
  Timeout = 4,
  Pending = 5,
}

export enum GenderPrefix {
  Mr = 1,
  Mrs = 3,
  Ms = 5,
}
export enum EmergencyContact {
  Mr = 1,
  Mrs = 3,
  Ms = 5,
}

export enum MethodPayment {
  Cash = 1,
  Transfer = 5,
  TransferByKConnect = 51,

  /*
  none = 0,
  cash = 1,
  cheque = 3,
  transfer = 5,
  creditCard = 7,
  pushPay = 9
  */
}
export enum PayrollStatus {
  draft = 0,
  awaiting = 1,
  reset = 2,
  paid = 3,
  partial = 4,
  rejected = 5,
  approved = 7,

  // pushPayAwaiting = 11,
  // pushPayProcessed = 13,
  // pushPayRejected = 15,
  // pushPayPartial = 17,
  // pushPayPendingPayments = 19,
  kConnectAwaiting = 50, // รอชำระเงิน
  kConnectProcessed = 52, // ชำระเงินแล้ว
  kConnectRejected = 54, // รายการไม่สำเร็จ
  kConnectPendingPayments = 56, // รอจ่ายชำระเพิ่ม
}
/**
 * @PayrollDetailStatus
 * @Status kConnectAwaiting = 50, // รอชำระเงิน
 * @Status kConnectProcessed = 52, // ชำระเงินแล้ว
 * @Status kConnectRejected = 54, // รายการไม่สำเร็จ
 * @Status kConnectPendingPayments = 56, // รอจ่ายชำระเพิ่ม
 */
export enum PayrollDetailStatus {
  draft = 0,
  awaiting = 1,
  reset = 2,
  paid = 3,
  rejected = 5,
  approved = 7,

  pushPayAwaiting = 11,
  pushPayProcessed = 13,
  pushPayRejected = 15,
  pushPayPartial = 17,
  pushPayPendingPayments = 19,

  kConnectAwaiting = 50, // รอชำระเงิน
  kConnectProcessed = 52, // ชำระเงินแล้ว
  kConnectRejected = 54, // รายการไม่สำเร็จ
  kConnectPendingPayments = 56, // รอจ่ายชำระเพิ่ม
}

export enum TaxReportStatus {
  awaiting = 1, // The frontend ui name will be "Pending Review / รอตรวจสอบ" for Tawi50 in th-en.json
  reset = 2,
  processing = 3,
  rejected = 5,
  approved = 7, // The frontend ui name will be "Reviewed / ตรวจสอบแล้ว" for Tawi50 in th-en.json
}

export enum EmployeeTaxReportStatus {
  awaiting = 1, // The frontend ui name will be "Pending Review / รอตรวจสอบ" for Tawi50 in th-en.json
  processing = 3,
  rejected = 5,
  approved = 7, // The frontend ui name will be "Reviewed / ตรวจสอบแล้ว" for Tawi50 in th-en.json
}

export enum PayrollType {
  firstVersion = 1,
  payrollPayment = 3,
  kconnect = 5,
}
export enum PayrollPaymentStatus {
  draft = 0,
  awaiting = 1,
  reset = 2,
  paid = 3,
  rejected = 5,
  approved = 7,
  kConnectAwaiting = 50, // รอชำระเงิน
  kConnectProcessed = 52, // ชำระเงินแล้ว
  kConnectRejected = 54, // รายการไม่สำเร็จ
  kConnectPendingPayments = 56, // รอจ่ายชำระเพิ่ม
}

export enum AdjustInventoryReason {
  Default = 0,
  DisastersFire = 1, //ภัยพิบัติ/อัคคีภัย
  StolenGoods = 3, //สินค้าสูญหาย
  StockWrittenOff = 5, //ทำลายสินค้า
  StockTakingResults = 7, //ปรับจำนวนสินค้าจากการนับสินค้า
  ReturnedStock = 9, //รับคืนสินค้า
  DamagedGoods = 11, //สินค้าชำรุด/เสื่อมสภาพ
  RawMaterialUsed = 13, //ตัดวัตถุดิบใช้ไป
  FinishedGoodsTransfer = 15, //รับโอนสินค้าสำเร็จรูป
  Other = 17, //อื่น
}
export enum PartialPaymentMethod {
  None = 1,
  Quantity = 3,
  Price = 5,
  Percentage = 7,
  RECPartial = 11,
}
export enum DocumentTemplates {
  // Default = 1,
  // Template1 = 3,
  // Template2 = 5,
  // Template3 = 7,
  // Template4 = 9,
  // Template5 = 11,
  // TemplateA5 = 13,
  // Template9x11withOriginal = 15,
  // Template8 = 17,
  NativeDefault = 101,
  Native1 = 103,
  Native3 = 105,
  Native5 = 107,
  Native7 = 109, // custom template
  Native9 = 111,
  Native11 = 113,
  Native13 = 115,
  Native17 = 117, // custom template
  Thermal1 = 201,
  // Thermal2 = 203,
  ShortCA1 = 301,
  ShortCA2 = 303,
  ShortCA3 = 305,
}
export enum Era {
  ce = 1, // Christian Era ค.ศ.
  be = 3, // Buddhist Era พ.ศ.
}
export enum SocketMessageMode {
  Insert = 0,
  Update = 1,
  Delete = 2,
}

export enum PermissionGroup {
  DocumentBuy = 1,
  DocumentSell = 3,
  SelfDocumentBuy = 5,
  SelfDocumentSell = 7,
  SelfCreditNoteDebitNote = 9,
  SelfWithHoldingTax = 11,
  Report = 13,
  Payroll = 15,
  SettingGL = 17,
  Setting = 19,
}
export enum DocumentCalculatorVersion {
  version1 = 1,
  version2 = 2,
}

export enum FlowAccountModules {
  Invoicing = 1,
  Expense = 3,
  UserPermissions = 5,
  Inventory = 7,
  CreditNoteAndDebitNote = 9,
  MultiCurrency = 11,
  MultiDocuments = 13,
  KPlusSME = 15,
  Payroll = 17,
  ETax = 19,
  PurchaseOrder = 21,
  Reconcile = 23,
  GeneralLedger = 25,
  KConnect = 27,
  AbbreviatedTaxInvoice = 29,
  AutoKey = 31,
  FixedAsset = 33,
  Deposit = 35,
  ConnectOpenAPI = 37,
  ConnectLazada = 39,
  PayrollBatchDocument = 41,
  PayrollOnlineDocument = 43,
  ProfitAndLossByProject = 45,
  MobilePOS = 47,
  BatchImport = 49,
  Warehouse = 53,
}

/* สำหรับแพ็คเกจที่ลูกค้าจะได้ตอนจ่ายเงิน */
export enum Packages {
  Basic = 63,
  Premium = 76,
  Advance = 60,
  FlowAccuntXKBank = 82,
}

export enum DeductionType {
  None = 0,
  CashDiscount = 1,
  Commission = 3,
  ManagementFee = 5,
  Roundings = 7,
  Retentions = 9,
  RoundingUp = 101,
}

export enum UpgradeType {
  Upgrade = 1,
  Renew = 3,
  ChangePackage = 5,
  Contraction = 7,
  Reactivate = 9,
}
export enum MISFormatProcessingStatus {
  // mis1 use 06
  // mis2 use 08, 09, 10

  /* case success enum */
  Warehouse = 4,
  Printed = 5,
  Issue = 6, // use in failed case too
  Cancelled = 7,
  GLRejected = 11,

  /* case failed enum */
  Stoppay = 8,
  Paid = 9,
  UnsucessCredit = 10,
}

export enum ResetDataType {
  Web = 1,
  Intranet = 3,
}

export enum ResetDataStatus {
  Pending = 10,
  Success = 30,
  Fail = 50,
}

export enum ProductTourStep {
  TourComplete = 999,
  TrackProductTourRecentUpdate = 998,
  PreTour = 0,
  CreateCompany = 1,
  CreateQT = 2,
  CreateINV = 3,
  AddTeamMember = 4,
}

export enum ProductTourStatus {
  InComplete = 0,
  Skip = 1,
  Complete = 3,
}

export enum Platform {
  web = 1,
  ios = 3,
  android = 5,
}

// Subscription
export enum PeriodType {
  Day = 1,
  Month = 2,
  Year = 3,
}

export enum PaymentChannel {
  System = -1,
  CreditCard = 1,
  IOS = 3,
  Android = 5,
  AIS_USSD = 7,
  AttachSlip = 9,
  PrePaidSerial = 11,
  Manual = 13,
  QRcode = 15,
  RedeemCredit = 17,
  DiscountPayment = 19,
}

export enum PackageStatus {
  Pending = 10,
  Approve = 30,
  Suspend = 50,
  Terminated = 70,
  Delete = 90,
}

export enum SubscriptionType {
  Package = 1,
  Bundle = 2,
  AddOn = 3,
}

export enum AppID {
  Flowaccount = 1,
  Payroll = 2,
  OCR = 3,
  MyCompany = 4,
  FlowConnect = 5,
  HQ = 6,
  CRM = 7,
}

export const AppText = {
  FLOWACCOUNT: 'FlowAccount',
  FLOWPAYROLL: 'FlowPayroll',
  OCR: 'Autokey',
  FLOWCONNECT: 'MyPlatform',
  MYCOMPANY: 'MyCompany',
}
export const AppTextMapping = {
  [AppID.Flowaccount]: AppText.FLOWACCOUNT,
  [AppID.Payroll]: AppText.FLOWPAYROLL,
  [AppID.OCR]: AppText.OCR,
  [AppID.FlowConnect]: AppText.FLOWCONNECT,
  [AppID.MyCompany]: AppText.MYCOMPANY,
}

export enum Status {
  Inactive = 0,
  Active = 1,
}
// End Subscription

export enum AppName {
  flowaccountNew = 'flowaccount-new',
  flowaccountPayroll = 'flowaccount-payroll',
  flowaccountMy = 'flowaccount-my',
  flowaccountCrm = 'flowaccount-intranet',
  flowaccountOCR = 'flowaccount-ocr',
  flowaccountFlowconnect = 'flowaccount-flowconnect',
}

export enum AutoBillingStatus {
  Awaiting = 0,
  QuotationCreated = 1,
  QuotationSendMail = 3,
  InvoiceCreated = 5,
  InvoiceSendMail = 7,
}

export enum CallStatus {
  Called = 1,
  CallAgain = 3,
  Unreachable = 5,
}

export enum BroadcastType {
  NewAndUpdate = 'newAndUpdate',
  Maintenance = 'maintenance',
  EventSeminarAcademy = 'eventSeminar',
}

export const Topic = {
  ...BroadcastType,
  MonthlyReport: 'monthlyReport',
  WeeklyReport: 'weeklyReport',
}

export enum TemplateType {
  MonthlySummary = 'monthlySummary',
  WeeklySummary = 'weeklySummary',
}

export enum AnalyticsLabel {
  newAndUpdate = 'new_and_update',
  maintenance = 'maintenance',
  eventSeminar = 'event_seminar',
  eventReminder = 'event_reminder',
}

export enum CancelledReason {
  AccountingFirmPartner = 0,
  CannotContact = 1,
  ClosedDownBusiness = 3,
  TooManyFeature = 5,
  FeatureMismatch = 7,
  MoreThanOneSubscriptions = 9,
  BadCustomerExperience = 11,
  NotSure = 13,
  MoveToPeak = 15,
  MoveToSmeMove = 17,
  MoveToTrCloud = 19,
  MoveToOther = 20,
  Other = 21,
}

export enum CallResult {
  Unknown = 0,
  Renewing = 1,
  Renewed = 3,
  Cancelled = 5,
  ChangePackage = 7,
}

export enum planStatus {
  Renewed = 1,
  Expiring = 3,
  Expired = 5,
}

export enum MessageStructure {
  string = 'string',
  json = 'json',
}

export enum EventNameTrigger {
  remove = 'REMOVE',
  insert = 'INSERT',
}

export enum SnsProtocol {
  Http = 'http',
  Https = 'https',
  Email = 'email',
  EmailJson = 'email-json',
  Sms = 'sms',
  Sqs = 'sqs',
  Application = 'application',
  Lambda = 'lambda',
}

export enum ModulePermissionPayroll {
  ViewPayrollSetting = 0,
  CreatePayrollSetting = 1,
  ViewPayroll = 2,
  CreatePayroll = 3,
  UpdatePayroll = 4,
  DeletePayroll = 5,
  AccessKConnect = 6,
  ViewPayrollKConnect = 7,
  CreatePayrollKConnect = 8,
  UpdatePayrollKConnect = 9,
  DeletePayrollKConnect = 10,
}

export enum AppPlatform {
  NewFlowAccount = 'FlowAccount_main',
  FlowAccountClassic = 'FlowAccount_classic',
}

export enum SqsAttributeDataTypes {
  String = 'String',
  Number = 'Number',
  Binary = 'Binary',
}

export enum TagKey {
  platform = 'platform',
  app = 'app',
  guid = 'guid',
}

export enum SqsMessageAttributeKey {
  messageId = 'messageId',
  messageType = 'messageType',
  isLastMessage = 'isLastMessage',
  stage = 'stage',
  dynamoId = 'dynamoId',
  createdAt = 'createdAt',
  guid = 'guid',
}

export enum NoteStatus {
  Open = 1,
  Pending,
  Resolve,
}

export enum OutboundStatus {
  Pending = 1,
  Called = 3,
  Unreachable = 5,
  Lead = 100,
  Qualified = 103,
  Sale = 105,
}

export enum NoteTypes {
  CustomerProfile = 1,
  OutboundCall = 3,
}

export enum ContactChannelType {
  Chat = 1,
  Email,
  Line,
  Facebook,
  Phone,
}

export enum SearchBy {
  Undefined = 0,
  CompanyId,
  CustomerID,
  Email,
  PhoneNumber,
  CompanySignup,
  CompanyLastSeen,
  UserLastSeen,
}

export enum SignupChannel {
  Undefined = 0,

  // CLASSIC WEB
  ClassicWeb = 100,
  ClassicWebMultipleCompany = 102,

  // CLASSIC iOS
  ClassiciOS = 120,
  ClassiciOSMultipleCompany = 122,

  // CLASSIC Android
  ClassicAndroid = 140,
  ClassicAndroidMultipleCompany = 142,
  ClassicMobile = 160,

  // ADVANCE WEB
  AdvanceWeb = 200,
  AdvanceWebMultipleCompany = 202,

  // ADVANCE PAYROLL WEB
  AdvancePayrollWeb = 210,
  AdvancePayrollWebMultipleCompany = 212,

  // ADVANCE iOS
  AdvanceiOS = 220,
  AdvanceiOSMultipleCompany = 222,

  // ADVNACE Android
  AdvanceAndroid = 240,
  AdvanceAndroidMultipleCompany = 242,

  // OTHERS
  Blog = 500,
  USSD = 600,
}

export enum AutoRenewLogStatus {
  Success = 1,
  Fail = 3,
  Pending = 5,
  SuccessManual = 7,
}

export enum Language {
  eng = 'EN',
  thai = 'TH',
}

// NOTE: - FlowWork
export enum MimeTypeUploadSupport {
  png = '.png',
  jpeg = '.jpeg',
  jpg = '.jpg',
  doc = '.doc', //Microsoft Word
  docx = '.docx', //Microsoft Word (OpenXML)
  xls = '.xls', //Microsoft Excel
  xlsx = '.xlsx', //Microsoft Excel (OpenXML)
  ppt = '.ppt', //Microsoft PowerPoint
  pptx = '.pptx', //Microsoft PowerPoint (OpenXML)
  csv = '.csv', //Comma-separated values (CSV)
  zip = '.zip', //ZIP archive
  rar = '.rar', //RAR archive
  pdf = '.pdf',
}

export enum UploadPrefix {
  original = 'original',
  fullsize = 'fullsize',
  thumbnail = 'thumbnail',
}

export enum AttachmentType {
  none = 0,
  image = 1,
  video = 3,
  other = 5,
  xcel = 7,
  pdf = 9,
  powerPoint = 11,
  doc = 13,
  unknown = 99,
}

export enum OutBoundCallingStatus {
  Default = 0,
  Interested = 1,
  InProgress = 3,
  Buyed = 5,
}

export enum CreditCardVendor {
  Omise = 1,
  KBank = 3,
}

// NOTE: RabbitMQ
export enum OptionKey {
  BroadcastWeb = 0,
  BroadcastMobile = 1,
  CompanyId = 2,
  UserId = 3,
  AccessToken = 4,
  CompanyIdUserId = 5,
}

export enum MessageTag {
  Company = 0,
  User = 1,
  Document = 2,
  Contact = 3,
  Product = 4,
  Journal = 5,
  Maintainance = 6,
  ProductStockCard = 7,
  ProductDetail = 8,
  DocumentList = 9,
  DocumentForm = 10,
  Employee = 11,
  EmployeeDetail = 12,
  Payroll = 13,
  PayrollForm = 14,
  BankAccount = 15,
  BankStatement = 16,
  ChartOfAccount = 17,
  FixedAssetListList = 18,
  FixedAssetForm = 19,
  FixedAssetMigrate = 20,
  AutoKeyProcessingStatus = 21,
  BatchDocument = 22,
  TotalFiles = 23,
  ReportQueue = 24,
}

export enum MessageMode {
  Insert = 0,
  Update = 1,
  Delete = 2,
}

export enum CouponStatus {
  Active = 1,
  Inactive = 3,
}

export enum CouponType {
  New = 1,
  Renew = 3,
  Upgrate = 5,
}

export enum AutokeyGalleryStatus {
  None = 0,
  Pending = 1,
  Failed = 3,
  Success = 5,
}

// NOTE: pdf-converter
export enum ImageTypeSupport {
  PNG = 'png',
  JPG = 'jpg',
}

export enum DocumentTypeQueue {
  report = 1,
}

// NOTE: Log service
export enum LogLevel {
  APP_INFO = 'APP_INFO',
  APP_DEBUG = 'APP_DEBUG',
  APP_WARN = 'APP_WARN',
  APP_ERR = 'APP_ERR',
}
export enum LogTypeNumber {
  controllerOrHandler = 100,
  middleware = 200,
  logic = 300,
  service = 400,
  cache = 500,
  bootstrap = 600,
  auth = 700,
  database = 800,
  thirdParty = 900,
  others = 1100,
  aws = 1000,
  aws_sqs = 1001,
  aws_user_analytics = 1002,
  aws_lambda_notification = 1003,
}

export enum BankingChannelType {
  BankAccount = 1,
  PettyCash = 3,
  Cheque = 5,
  CreditCard = 7,
  OtherChannel = 9,
  OtherBank = 11,
}

export enum PaymentChannelsType {
  POS = 1,
  PayemntGateWay = 3,
  EDC = 5,
  ECommerce = 7,
}

export enum DepositDocumentType {
  None = 0,
  First = 1,
  Last = 2,
}

export enum SupplierInvoiceStatus {
  None = 0,
  Awaiting = 1,
  WaitingForRefund = 3,
  CreatedBatchFilling = 5,
  NoRefund = 7,
  AwaitingPP36 = 9, // new status
  WaitingToPayPP36 = 11, // new status
  AwaitingTaxReceipt = 13, // new status
}

export enum SupplierInvoiceAction {
  Refund = 1,
  NoRefund = 3,
  Create = 5,
  Reset = 7,
}

export enum BatchTaxFilingTaxForm {
  PP30 = 1,
  PP36 = 3,
}

export enum PaymentPaynowMethodType {
  None = 0,
  StripeCreditCard = 1,
  StripePromptPay = 3,
  BankTransfer = 5,
  OmiseCreditCard = 7,
}

export enum PaymentPaynowStatus {
  None = 0,
  Awaiting = 1,
  Pending = 3,
  Successed = 5,
  Failed = 7,
}

export enum PaymentPaynowVerifyStatus {
  None = 0,
  DocumentHasVoided = 100,
  DocumentHasDeleted = 101,
  PaidByPaymentGateway = 200,
  PaidByFlowAccount = 201,
  PaidByBankTransfer = 202,
  FailedByPaymentGateway = 300,
  IntegrationDisconnected = 400,
  PaymentAmountUpdated = 500,
}

export enum PaymentChannelChoices {
  None = 0,
  Existing = 1,
  New = 2,
  NoAutoStatus = 3,
}

export enum SetUpWizardStatusEnum {
  None = 0, //ค่าเริ่มต้น — HIDE
  Success = 1, //save สำเร็จที่ popup ตั้งค่าเริ่มต้น — HIDE
  SuccessBySetting = 2, //สำเร็จจากหน้า setting — HIDE
  NeverShowAgain = 3, //ไม่ต้องแสดงอีก — HIDE
  Pending = 5, //sign up wizard (ใหม่) สำเร็จ — SHOW
}

export enum AcceptType {
  document = 'document',
  documentNotRarZip = 'documentNotRarZip',
  photo = 'photo',
  photoAndPdf = 'photo&pdf',
}

export enum ConfirmFilesType {
  AttachedFiles = 1,
  QrCode = 3,
  ImageFile = 5,
}

export enum ConfirmDialogAction {
  LeftButton = 1,
  RightCancleButton = 3,
  RightSubmitButton = 5,
  CloseButton = 7,
}

export enum DevicePlatform {
  Unknow = 0,
  Web = 1,
  iOS = 3,
  Android = 5,
}

export enum MyPlatformChannel {
  Lazada = 'Lazada',
  Shopee = 'Shopee',
  Stripe = 'Stripe',
  Omise = 'Omise',
  KBank = 'KBank',
  TikTokShop = 'TikTokShop',
}
//ETax Invoice by Email
export enum ETaxEmailStatus {
  None = 0,
  Sent = 1,
  Edit = 3,
  Cancel = 5,
}

export enum ProjectStatus {
  Success = 0,
  Duplicate = 95007,
  Undefined = 95009,
  DocumentExist = 95011,
}

export enum ReasonForCancelInvoice {
  TIVC00 = 0,
  TIVC01 = 1,
  TIVC02 = 3,
  TIVC99 = 99,
}

export enum BatchMetadataStatusType {
  pending = 1,
  failed = 3,
  success = 5,
  send = 7,
}

export enum BatchMessageStatusType {
  pending = 1,
  failed = 3,
  success = 5,
}

export enum PaynowGateway {
  Stripe = 1,
  Omise = 3,
  KBank = 5,
}

export enum MyPlatformSettingType {
  PaymentChannel = 1,
  ApiKey = 3,
  DocumentSetting = 5,

  ReauthorizedSetting = 7,
}
// for bank transfer
export enum PettyCashTransferType {
  Topup = 1,
  Transfer = 3,
}
export enum CreditCardType {
  Personal = 1,
  Business = 3,
}

export enum ShopListType {
  View = 'View',
  Edit = 'Edit',
}

export enum ConfirmationType {
  Delete = 'Delete',
  Submit = 'Submit',
}

export enum FeatureExtendType {
  freetrial = 1,
  module = 2,
  addon = 3,
}

export enum ErrorExeptions {
  documentIdIsDuplicate = 1, // Document ID ซ้ำกัน
  documentIdIsRequired = 2, // Document ID ไม่มีข้อมูล
  subCategoryIsRequired = 3, // ประเภทความผิดพลาดไม่มีข้อมูล
  publicOnIsRequired = 4, // ไม่มีข้อมูล ช่วงวันที่ตรวจสอบเอกสาร
  documentTypeIsRequired = 5, // ไม่มีข้อมูล ประเภทของเอกสาร
  auditGrandTotalIsRequired = 6, // ไม่มีข้อมูลจำนวนเงิน
  auditIsImpact = 8, // ไม่มีข้อมูลประเมินผลกระทบ
  adminActionIsRequired = 9, // ส่งข้อมูลให้ลูกค้าตรวจสอบ ไม่มีข้อมูล
  auditPeriodDateIsRequired = 10, // ช่วงวันที่ตรวจสอบเอกสารไม่มีข้อมูล
  dateFormat = 11, // รูปแบบวันที่ในเอกสารไม่ถูกต้อง
  documentKeyIsRequired = 12, // รหัสบริษัทไม่มีข้อมูล
  journalEntryIsRequired = 13, // ไม่มีข้อมูล เลขที่สมุดรายวัน (สำหรับตรวจสอบ)
  supportCodeIsRequired = 14, // รหัสลูกค้าไม่มีข้อมูล
  auditOnIsRequired = 15, // วันที่สแกนไม่มีข้อมูล
  companyIdIsRequired = 16, // CompanyId ไม่มีข้อมูล
  notSupportFileType = 17, // ประเภทของไฟล์ ไม่ถูกต้อง
  cannotUploadFileToPresignUrl = 18, // ไม่สามารถโหลดไฟล์ขึ้น AWS ได้
  documentIsNotData = 19, // เอกสารไม่มีข้อมูล
  inventoryErrorIsRequired = 21, // สถานะตัดสต๊อก
  inventoryReasonIsRequired = 23, // สาเหตุ,
}
export enum EmailDialogTab {
  shareDocumentTab = 0,
  emailTab = 1,
}

export enum OpenPlatformName {
  Shopee = 'shopee',
  Lazada = 'lazada',
}

export enum PaidPeriod {
  Monthly = 1,
  Daily = 3,
}

export enum SendEmailStatus {
  Sent = 1,
  NoEmail = 3,
}

export enum OtherChannelsType {
  Receive = 1,
  ReceivePay = 3,
  Pay = 5,
}

/* Typeahead Category */
export enum TypeaheadCategory {
  ProductList = 1,
  SalesList = 3,
  DocumentContactList = 5,
  ContactList = 7,
  ProjectList = 9,
}

export enum BatchActionTypeEnum {
  None = 0,
  BatchPrint = 1,
  BatchDownload = 3,
  BatchStatus = 5,
}

export enum GenTaxBusinessType {
  Corporation = 1,
  Individual = 3,
}

export enum GenTaxHeadOrBranch {
  HeadOffice = 1,
  Branch = 2,
}
export enum BatchActionMetadataStatus {
  Pending = 1,
  Processing = 3,
  PartialSuccess = 4,
  Completed = 5,
  Read = 6,
  Failed = 7,
  FailRetryExceed = 9,
}

export enum AuditDocumentAction {
  Create = 1,
  Update = 3,
  View = 5,
  Upload = 7,
  Upgrade = 9,
  Delete = 11,
  BatchCreate = 13,
  BatchUpdate = 15,
  BatchUpgrade = 17,
  BatchDelete = 19,
  ChangeStatus = 21,
  Payment = 23,
  DonateDestroy = 25,
  ResetPayment = 25,
  //KCashPayment = 27,
  //KCashResetPayment = 29,
  ChangeStatusSupplierInvoice = 27,
  UpdateAssetCategory = 29,
  KCashPayment = 31,
  KCashResetPayment = 33,
  PaymentUpdate = 101,
  DeleteAttachment = 103,
  JVUpdate = 201,
  JVUpload = 203,
  UpdateStatus = 301,
  Void = 401,
  Reset = 501,
  AttachInvoice = 601,
  UpdateInvoice = 603,
  DeleteInvoice = 605, // Delete and Reset
  NoRefund = 607,
  ResetNoRefund = 609,
  AttachRDReceipt = 611,
  UpdateRDReceipt = 613,
  DeleteRDReceipt = 615, //Reset from WaitingForRefund to AwaitingTaxReceipt PP36
  VoidPaymentFilingPP36 = 617,
  DeleteFilingPP30 = 619,
  DeleteFilingPP36 = 621,
}

export enum PackageLevel {
  Free = 0,
  Standard = 1,
  Pro = 2,
  ProBusiness = 3,
}

export enum PartnerPackage {
  FreeTrial = 1,
  Silver = 3,
  Gold = 5,
  Platinum = 7,
  Diamond = 9,
}

export enum PartnerTier {
  FreeTrial = 1,
  Silver = 3,
  Gold = 5,
  Platinum = 7,
  Diamond = 9,
}

export enum ErrorResWarehouse {
  Movement = 990002,
  Name = 990003,
  Code = 990004,
  InvalidWarehouseId = 990005,
  Create = 990006,
  Update = 990007,
  System = 990008,
  ChangeStatus = 1000002,
}

export enum ChartType {
  SourceOfIncome = 1,
  CollectedSummary = 3,
  Expense = 5,
  PaymentSummary = 7,
  Cash = 9,
  IncomeExpense = 11,
  OutstandingInvoices = 13,
  OutstandingPayments = 15,

  /* Payroll Chart Type */
  PayrollExpense = 17,
  Employee = 19,
  PayrollPayment = 21,
  Tawi50 = 23,
}

export enum ConditionsWithholdingTax {
  WithholdsTaxAtSource = 1,
  PayEveryTime = 2,
  PayOneTime = 3,
}

export enum ErrorMessageDeleteUnit {
  CantDelete = 'cannot delete in use product unit',
  CantFind = 'cannot find product to delete',
  CantDeleteShared = 'cannot delete shared product unit',
}

export enum TypeWarehouseModal {
  Subscription = 1,
  Upgrade = 2,
  Renew = 3,
}

export enum SendEventWarehouse {
  createW = 'WarehouseCreate',
  setDefaultW = 'WarehouseSetasDefault',
  inDoc = 'WarehouseInDoc',
  inAdjust = 'WarehouseInAdjustment',
  inTransfer = 'WarehouseInTransfer',
}

export enum BatchFillingStatus {
  Awaiting = 1,
  Refunded = 3,
}

export enum SignUpType {
  None = 0,
  FlowAccount = 1,
  FlowPayroll = 3,
  MobilePOS = 5,
  AutoKey = 7,
  PackageForeverFree = 9,
  PackageStandard = 11,
  PackagePro = 13,
  PackageProBusiness = 15,
  LandingQuotation = 17,
  LandingReceipt = 19,
  LandingInvoice = 21,
  LandingECommerce = 23,
}

export enum EmptyTable {
  default = 'default',
  noData = 'noData',
  queue = 'queue',
  crm = 'crm',
}

export enum AdjustReason {
  thDisastersFire = 'ภัยพิบัติ/อัคคีภัย',
  thStolenGoods = 'สินค้าสูญหาย',
  thStockWrittenOff = 'ทำลายสินค้า',
  thStockTakingResults = 'ปรับจำนวนสินค้าจากการนับสินค้า',
  thReturnedStock = 'รับคืนสินค้า',
  thDamagedGoods = 'สินค้าชำรุด/เสื่อมสภาพ',
  thRawMaterialUsed = 'ตัดวัตถุดิบใช้ไป',
  thFinishedGoodsTransfer = 'รับโอนสินค้าสำเร็จรูป',
  enDisastersFire = 'Disasters/Fire',
  enStolenGoods = 'Stolen goods',
  enStockWrittenOff = 'Stock written off',
  enStockTakingResults = 'Stock taking adjustment',
  enReturnedStock = 'Returned stock',
  enDamagedGoods = 'Damaged goods',
  enRawMaterialUsed = 'Raw material used',
  enFinishedGoodsTransfer = 'Finished goods transfer',
}

export enum PurposeWarehouse {
  PRODUCT_STORAGE = 1,
  RAW_METERIAL_STORAGE = 3,
  BRANCH = 5,
  HEADQUARTER = 7,
  CONSIGNMENT = 9,
  ECOMMERCE_PLATFORM = 11,
  DISTRIBUTION_CENTER = 13,
  SEASONAL_STOCKINK = 15,
  OTHER = 99,
}

export enum docInlineVatDiscount {
  simple = 101,
  simpleWithDiscount = 102,
  inlineDiscount = 103,
  inlineVatInlineDiscount = 104,
}

export enum docCategoryEventKey {
  original = 101,
  deposit = 102,
  partial = 103,
}

export enum AccountingFirmCompanyStatus {
  Register = 1,
  PendingKYC = 3,
  Active = 5,
  InActive = 7,
}

export enum RenewalTypeEnum {
  CreditRedeem = 1,
  Discount = 3,
  System = 5,
}

export enum SubscriptionActionType {
  Delete = 3,
}
